export const formatPhoneNumber = (value: string) => {
  // 숫자가 아닌 모든 문자를 제거
  let formattedValue = value.replace(/\D/g, "");

  // 3자리(010), 4자리(중간), 4자리(끝)로 하이픈 추가
  if (formattedValue.length > 7) {
    formattedValue = formattedValue.replace(
      /(\d{3})(\d{4})(\d{0,4})/,
      "$1-$2-$3"
    );
  } else if (formattedValue.length > 3) {
    formattedValue = formattedValue.replace(/(\d{3})(\d{0,4})/, "$1-$2");
  }

  // 하이픈을 포함하여 최대 13자까지만 허용 (010-1234-1234)
  if (formattedValue.length > 13) {
    formattedValue = formattedValue.slice(0, 13);
  }

  return formattedValue;
};
